import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ valuesField, methods, formProps }) => {
  const { intl } = formProps || {};
  return {
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'therapy.groupName' }),
      placeholder: intl.formatMessage({ id: 'therapy.groupNameEnter' }),
      autoFocus: true,
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = ({ formProps }) => {
  return [
    {
      id: 'info',
      fields: ['name'],
    },
  ];
};

export const groupImageIndicationFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
